import { render, staticRenderFns } from "./OptometristInventory.vue?vue&type=template&id=a8ad9d9e&scoped=true&"
import script from "./OptometristInventory.vue?vue&type=script&lang=js&"
export * from "./OptometristInventory.vue?vue&type=script&lang=js&"
import style0 from "./OptometristInventory.vue?vue&type=style&index=0&id=a8ad9d9e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8ad9d9e",
  null
  
)

export default component.exports